export default __webpack_public_path__ + "static/media/in_in_icon.52b2e881.svg";